import {
  Chart,
  LineController,
  LineElement,
  PointElement,
  LinearScale,
  CategoryScale,
  Filler,
  Tooltip,
  Legend,
} from "chart.js"

Chart.register(
  LineController,
  LineElement,
  PointElement,
  LinearScale,
  CategoryScale,
  Filler,
  Tooltip,
  Legend
)

// Line chart with clickable [data-stat-chartjs] toggles (job activity page).
export function initChartWithStats({
  canvas,
  datasets,
  labels,
  options = {},
  defaultDataset = null,
  root = document,
}) {
  const ctx = typeof canvas === "string" ? document.getElementById(canvas) : canvas
  if (!ctx) return null

  const defaultColors = {
    borderColor: "#15803d",
    backgroundColor: "rgba(21, 128, 61, 0.1)",
    tension: 0.4,
    fill: true,
  }

  const processedDatasets = datasets.map((dataset) => ({
    ...defaultColors,
    ...dataset,
  }))

  const chartOptions = Object.assign(
    {
      responsive: true,
      maintainAspectRatio: false,
      interaction: { intersect: false },
      plugins: {
        legend: {
          display: false,
          labels: {
            font: {
              family: "Geist, sans-serif",
            },
          },
        },
      },
      animation: { duration: 0 },
      scales: {
        x: {
          display: true,
          ticks: {
            color: "#6b7280",
            font: {
              family: "Geist, sans-serif",
            },
          },
          grid: { color: "#e5e7eb" },
        },
        y: {
          display: true,
          ticks: {
            color: "#6b7280",
            font: {
              family: "Geist, sans-serif",
            },
          },
          grid: { color: "#e5e7eb" },
        },
      },
    },
    options
  )

  const chart = new Chart(ctx, {
    type: "line",
    data: { labels, datasets: processedDatasets },
    options: chartOptions,
  })

  const statBoxes = root.querySelectorAll("[data-stat-chartjs]")

  function selectStat(label) {
    statBoxes.forEach((box) => {
      box.setAttribute(
        "data-selected",
        box.getAttribute("data-stat-chartjs") === label.toLowerCase() ? "true" : "false"
      )
    })
    chart.data.datasets.forEach((dataset, idx) => {
      chart.setDatasetVisibility(idx, dataset.label.toLowerCase() === label.toLowerCase())
    })
    chart.update()
  }

  if (defaultDataset) selectStat(defaultDataset)

  statBoxes.forEach((box) => {
    const statChartJSAtr = box.getAttribute("data-stat-chartjs")
    if (statChartJSAtr && statChartJSAtr.trim() !== "") {
      box.addEventListener("click", function () {
        selectStat(this.getAttribute("data-stat-chartjs"))
      })
    }
  })

  return chart
}
